/* SleepKarma — Hydrating Mouth Tape PDP behaviour (gallery, pack selector,
   refill, quantity-based cart-drawer add-to-cart, before/after drag, review
   carousel, video modal, scroll reveal). Ported from the designer V1 build.
   PRODUCT falls back to window.SK_PRODUCT; galleryImages to window.SK_HMT_GALLERY. */

/* !!! DO NOT PUBLISH AS-IS !!!
       The six reviews below are FABRICATED placeholders — invented quotes and invented
       names, shown with a "Verified Buyer" badge. They exist to show the module at a
       realistic length and tone. Hydrating Bamboo Mouth Tape has no verified reviews
       yet; replace every entry with a real Okendo pull before launch. */
    var reviewsList = [
      { name: 'Jess M.',     hook: '“Three weeks in and my lips aren’t cracking.”',
        body: ' Every winter I wake up peeling. Now I put this on after my night routine and forget about it — easiest step I’ve added.' },
      { name: 'Danielle R.', hook: '“The gel pad is the whole thing.”',
        body: ' I’d used plain mouth tape before and it did nothing for dryness. This actually leaves them soft by morning.' },
      { name: 'Simone T.',   hook: '“Gentle enough for my sensitive skin.”',
        body: ' I was nervous about adhesive that close to my mouth. No redness, and it peels off without any tugging.' },
      { name: 'Kayla B.',    hook: '“Lipstick sits so much better now.”',
        body: ' Less flaking means less patchiness. I noticed it around week two, mostly on the bottom lip. My matte formulas don’t catch anymore.' },
      { name: 'Rachel D.',   hook: '“I stopped waking up parched.”',
        body: ' The nose-breathing part was a bonus I wasn’t expecting. I sleep through instead of waking at 3am for water.' },
      { name: 'Amara O.',    hook: '“It stays put all night.”',
        body: ' I’m a side sleeper and assumed it would end up somewhere on the pillow. Still on every morning, and it comes off in one clean piece.' }
    ];
    var currentReviewIndex = 0;
    function showReview(i) {
      // Wrap around in both directions
      if (i < 0) i = reviewsList.length - 1;
      if (i >= reviewsList.length) i = 0;
      currentReviewIndex = i;
      var r = reviewsList[i];
      var contentEl = document.getElementById('review-content');
      // Fade out, swap, fade in
      contentEl.style.opacity = '0';
      setTimeout(function() {
        contentEl.innerHTML = '<div class="mini-testimonial-top"><span class="mini-testimonial-stars">★★★★★</span><span class="mini-testimonial-name">' + r.name + '</span><span class="verified-badge">✓ Verified Buyer</span></div><div class="mini-testimonial-text"><strong>' + r.hook + '</strong>' + r.body + '</div>';
        contentEl.style.opacity = '1';
      }, 250);
      // Always show both arrows (we loop now)
      document.getElementById('review-prev').classList.remove('hidden');
      document.getElementById('review-next').classList.remove('hidden');
    }
    // Show a random review on each page load
    showReview(Math.floor(Math.random() * reviewsList.length));

// ==================================================
// PRODUCT DATA — All variant IDs, selling plans, pricing
// ==================================================
// Live Shopify data — Hydrating Bamboo Mouth Tape (variant 48441261719793, sku SK-HBMT-30).
// NOTE: only the single 1-pack variant exists in Shopify today. The 3- and 6-pack
// tiers post the same variant at quantity 3 and 6 until dedicated variants and Skio
// selling plans are created. Selling-plan IDs below are PLACEHOLDERS.
const PRODUCT = window.SK_PRODUCT || {
  variants: {
    '1':  { id: 48441261719793, title: 'Hydrating Bamboo Mouth Tape / 1 Pack',  qty: 1 },
    '3':  { id: 48441261719793, title: 'Hydrating Bamboo Mouth Tape / 3 Packs', qty: 3 },
    '6':  { id: 48441261719793, title: 'Hydrating Bamboo Mouth Tape / 6 Packs', qty: 6 },
  },
  sellingPlans: {
    '1': { id: 5171773681, price: 4197, label: '$41.97', save: '30%' },
    '3': { id: 5171740913, price: 3297, label: '$32.97', save: '45%' },
    '6': { id: 5171806449, price: 2998, label: '$29.98', save: '50%' },
  },
  oneTimePricePerMonth: 5995,
  packs: {
    '1': { months: 1, oneTimeTotal: '$59.95',  oneTimeOrig: null, perMonth: '$59.95' },
    '3': { months: 3, oneTimeTotal: '$179.85', oneTimeOrig: null, perMonth: '$59.95' },
    '6': { months: 6, oneTimeTotal: '$359.70', oneTimeOrig: null, perMonth: '$59.95' },
  },
  subPacks: {
    '1': { total: '$41.97',  orig: '$59.95',  perMonth: '$41.97', save: '30%' },
    '3': { total: '$98.91',  orig: '$179.85', perMonth: '$32.97', save: '45%' },
    '6': { total: '$179.88', orig: '$359.70', perMonth: '$29.98', save: '50%' },
  },
};

// ==================================================
// STATE
// ==================================================
let state = {
  pack: '3',             // '1', '3', or '6' — default to 3 month (most popular)
  isSubscription: true,  // refill toggle on by default
};

// ==================================================
// IMAGE GALLERY
// ==================================================
var galleryImages = window.SK_HMT_GALLERY || [
  'Page Images/feature-1-packaging.jpg',
  'Page Images/feature-2-key-benefits.jpg',
  'Page Images/feature-4-how-to-use.jpg',
  'Page Images/feature-5-before-after.jpg',
  'Page Images/feature-6-whats-in-the-box.jpg',
  'Page Images/feature-7-review.jpg',
  'Page Images/feature-8-routine.jpg',
];

let currentImageIndex = 0;
function setImage(index) {
  currentImageIndex = index;
  document.getElementById('main-image').src = galleryImages[index];
  document.getElementById('gallery-counter').textContent = (index + 1) + ' / ' + galleryImages.length;
  document.querySelectorAll('.gallery-thumb').forEach((t, i) => {
    t.classList.toggle('active', i === index);
  });
  // Show/hide arrows based on position
  const prevBtn = document.querySelector('.gallery-arrow.prev');
  const nextBtn = document.querySelector('.gallery-arrow.next');
  if (prevBtn) prevBtn.classList.toggle('hidden', index === 0);
  if (nextBtn) nextBtn.classList.toggle('hidden', index === galleryImages.length - 1);
}
function prevImage() {
  if (currentImageIndex > 0) setImage(currentImageIndex - 1);
}
function nextImage() {
  if (currentImageIndex < galleryImages.length - 1) setImage(currentImageIndex + 1);
}

// Swipe support (touch + mouse drag)
(function() {
  var el = document.getElementById('gallery-main');
  if (!el) return;
  var startX, startY, isDragging = false;

  // Prevent native image drag on ALL images inside gallery
  var imgs = el.getElementsByTagName('img');
  for (var i = 0; i < imgs.length; i++) {
    imgs[i].draggable = false;
    imgs[i].addEventListener('dragstart', function(e) { e.preventDefault(); });
  }

  function getX(e) {
    if (e.touches) return e.touches[0].clientX;
    return e.clientX;
  }
  function getY(e) {
    if (e.touches) return e.touches[0].clientY;
    return e.clientY;
  }
  function getEndX(e) {
    if (e.changedTouches) return e.changedTouches[0].clientX;
    return e.clientX;
  }
  function getEndY(e) {
    if (e.changedTouches) return e.changedTouches[0].clientY;
    return e.clientY;
  }

  function onStart(e) {
    isDragging = true;
    startX = getX(e);
    startY = getY(e);
    // Only preventDefault for mouse (not touch, to allow scroll)
    if (!e.touches) e.preventDefault();
  }
  function onEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    var dx = getEndX(e) - startX;
    var dy = getEndY(e) - startY;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0) { nextImage(); } else { prevImage(); }
    }
  }
  function onCancel() { isDragging = false; }

  // Touch
  el.addEventListener('touchstart', onStart, { passive: true });
  el.addEventListener('touchend', onEnd);
  el.addEventListener('touchcancel', onCancel);

  // Mouse
  el.addEventListener('mousedown', onStart);
  window.addEventListener('mouseup', onEnd);
  window.addEventListener('mouseleave', onCancel);

  // Also set cursor style
  el.style.cursor = 'grab';
  el.addEventListener('mousedown', function() { el.style.cursor = 'grabbing'; });
  window.addEventListener('mouseup', function() { el.style.cursor = 'grab'; });
})();

// ==================================================
// PACK SELECTION
// ==================================================
function selectPack(pack) {
  state.pack = pack;
  document.querySelectorAll('.pack-card').forEach(c => c.classList.remove('selected'));
  document.querySelector('.pack-card[data-pack="' + pack + '"]').classList.add('selected');
  updatePackCards();
  updateUI();
}

// ==================================================
// REFILL / SUBSCRIBE TOGGLE
// ==================================================
function toggleRefill() {
  state.isSubscription = !state.isSubscription;
  const toggle = document.getElementById('refill-toggle');
  const check = document.getElementById('refill-check');
  toggle.classList.toggle('active', state.isSubscription);
  document.getElementById('refill-row').classList.toggle('active', state.isSubscription);
  check.textContent = state.isSubscription ? '✓' : '';
  document.querySelector('.pack-cards').classList.toggle('compact', !state.isSubscription);
  var bestDeal = document.querySelector('.pack-badge.best-deal');
  if (bestDeal) bestDeal.style.display = state.isSubscription ? '' : 'none';
  updatePackCards();
  updateUI();
}

// ==================================================
// UPDATE PACK CARD PRICES (when toggling subscription)
// ==================================================
function updatePackCards() {
  ['1', '3', '6'].forEach(p => {
    const perMonthEl = document.getElementById('pack-' + p + '-permonth');
    const origEl = document.getElementById('pack-' + p + '-orig');
    const totalEl = document.getElementById('pack-' + p + '-total');
    const discountEl = document.getElementById('pack-' + p + '-discount');

    if (state.isSubscription) {
      const sub = PRODUCT.subPacks[p];
      perMonthEl.innerHTML = sub.perMonth + '<span class="pack-price-permonth-label">/mo</span>';
      origEl.textContent = PRODUCT.packs[p].perMonth;
      origEl.style.visibility = 'visible';
      discountEl.textContent = sub.save + ' OFF';
      discountEl.style.display = '';
      if (totalEl) { totalEl.textContent = sub.total + ' total'; }
    } else {
      const pack = PRODUCT.packs[p];
      perMonthEl.innerHTML = pack.perMonth + '<span class="pack-price-permonth-label">/pack</span>';
      origEl.style.visibility = 'hidden';
      discountEl.style.display = 'none';
      if (totalEl) {
        totalEl.textContent = pack.oneTimeTotal + ' total';
      }
    }
  });

  // Update "You save $X" box — calculate actual dollar savings
  const saveBox = document.getElementById('refill-save-box');
  if (state.isSubscription) {
    const months = parseInt(state.pack);
    const oneTimeTotal = PRODUCT.oneTimePricePerMonth * months; // in cents
    const subTotal = parseFloat(PRODUCT.subPacks[state.pack].total.replace('$', '').replace(',', '')) * 100;
    const saved = ((oneTimeTotal - subTotal) / 100).toFixed(2);
    saveBox.textContent = 'You save $' + saved;
    // Also update CTA savings line
    const ctaSavings = document.getElementById('cta-savings-line');
    if (ctaSavings) {
      ctaSavings.innerHTML = 'You save <span>$' + saved + '</span> on this order';
      ctaSavings.style.display = 'block';
    }
  } else {
    const ctaSavings = document.getElementById('cta-savings-line');
    if (ctaSavings) ctaSavings.style.display = 'none';
  }

  // Toggle subscription benefits + delivery line visibility
  document.querySelectorAll('.pack-benefits, .pack-deliver').forEach(el => {
    if (state.isSubscription) {
      el.classList.add('visible');
    } else {
      el.classList.remove('visible');
    }
  });
}

// ==================================================
// UI UPDATE — main price row, CTA, sticky bar
// ==================================================
function updateUI() {
  const total = state.isSubscription
    ? PRODUCT.subPacks[state.pack].total
    : PRODUCT.packs[state.pack].oneTimeTotal;
  const origTotal = state.isSubscription ? PRODUCT.subPacks[state.pack].orig : null;

  // resetCTAButton() is the single source of truth for the button markup, so the
  // price row can never get stuck after add-to-cart removes the #cta-price span
  // (e.g. on a back/forward-cache return).
  resetCTAButton();

  const stickyPriceEl = document.getElementById('sticky-price');
  if (stickyPriceEl) {
    if (state.isSubscription) {
      stickyPriceEl.innerHTML = total + ' <span style="text-decoration:line-through;color:var(--gray-400);font-weight:400;">' + origTotal + '</span>';
    } else {
      stickyPriceEl.textContent = total;
    }
  }
}

// ==================================================
// START NOW — Shopify AJAX Cart API
// ==================================================
function addToCart() {
  var btn = document.getElementById('add-to-cart-btn');
  var successEl = document.getElementById('cart-success');

  // Hydrating mouth tape: single SKU; the pack (1/3/6) is a QUANTITY multiplier.
  var variant = PRODUCT.variants[state.pack];
  if (!variant) { alert('Error: Could not find variant. Please try again.'); return; }

  var payload = { id: variant.id, quantity: variant.qty };
  if (state.isSubscription) { payload.selling_plan = PRODUCT.sellingPlans[state.pack].id; }

  btn.classList.add('loading');
  btn.innerHTML = '⏳ Adding to cart...';

  var cartDrawer = document.querySelector('cart-drawer');
  var drawerSections = cartDrawer && cartDrawer.getSectionsToRender
    ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
    : ['cart-drawer', 'cart-icon-bubble'];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [payload], sections: drawerSections.join(',') })
  })
  .then(function (r) { if (!r.ok) throw new Error('Cart API returned ' + r.status); return r.json(); })
  .then(function (data) {
    btn.classList.remove('loading');
    btn.innerHTML = '✅ Added!';
    if (cartDrawer && cartDrawer.renderContents && data.sections) {
      cartDrawer.renderContents(data, true);
      setTimeout(function () { if (!cartDrawer.isOpen) { cartDrawer.toggleDrawerClasses(); } }, 100);
    } else {
      setTimeout(function () {
        var t = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, a[href="/cart"]');
        if (t) t.click();
      }, 500);
    }
    setTimeout(function () { resetCTAButton(); }, 3000);
  })
  .catch(function (error) {
    btn.classList.remove('loading');
    var isShopify = window.location.hostname.indexOf('sleepkarma') > -1 || window.location.hostname.indexOf('myshopify') > -1;
    if (isShopify) {
      btn.innerHTML = '❌ Error — please try again';
      setTimeout(function () { resetCTAButton(); }, 2000);
    } else {
      var price = state.isSubscription ? PRODUCT.subPacks[state.pack].total : PRODUCT.packs[state.pack].oneTimeTotal;
      successEl.innerHTML = '<div class="cart-success-text">🔧 Preview Mode — This would add to cart:</div>' +
        '<div style="font-size:13px;color:#555;margin-bottom:8px;">Variant: <strong>' + variant.title + '</strong> (ID: ' + variant.id + ') × qty ' + variant.qty + '<br>' +
        (state.isSubscription ? 'Selling Plan: <strong>' + state.pack + '-month subscription</strong> (ID: ' + PRODUCT.sellingPlans[state.pack].id + ')<br>' : 'One-time purchase<br>') +
        'Price: <strong>' + price + '</strong></div>';
      successEl.classList.add('show');
      resetCTAButton();
    }
  });
}

function resetCTAButton() {
  const btn = document.getElementById('add-to-cart-btn');
  const total = state.isSubscription ? PRODUCT.subPacks[state.pack].total : PRODUCT.packs[state.pack].oneTimeTotal;
  const origTotal = state.isSubscription ? PRODUCT.subPacks[state.pack].orig : '';
  btn.innerHTML = '<span class="cta-lock"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span> START NOW — <span class="cta-price">' + total + '</span>' + (state.isSubscription ? ' <span class="cta-original">' + origTotal + '</span>' : '');
}

// ==================================================
// BB FAQ TOGGLE — lock scroll position for full animation
// ==================================================
function bbFaqToggle(btn) {
  var scrollY = window.scrollY;
  btn.parentElement.classList.toggle('open');
  // Lock scroll for the entire 450ms transition
  var id = setInterval(function() { window.scrollTo(0, scrollY); }, 16);
  setTimeout(function() { clearInterval(id); }, 500);
}

// ==================================================
// STICKY BAR — IntersectionObserver
// ==================================================
const heroCta = document.getElementById('add-to-cart-btn');
const finalCta = document.querySelector('.final-cta-button');
const stickyBar = document.getElementById('sticky-bar');
let heroBelowViewport = false, finalCtaVisible = false;
const stickyUpdate = () => stickyBar.classList.toggle('visible', heroBelowViewport && !finalCtaVisible);
const heroObs = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    // Show sticky only when CTA is above viewport (user scrolled past it downward)
    heroBelowViewport = !e.isIntersecting && e.boundingClientRect.top < 0;
    stickyUpdate();
  });
}, { threshold: 0 });
heroObs.observe(heroCta);
if (finalCta) {
  const finalObs = new IntersectionObserver((entries) => {
    entries.forEach(e => { finalCtaVisible = e.isIntersecting; stickyUpdate(); });
  }, { threshold: 0.1 });
  finalObs.observe(finalCta);
}

// Initialize UI
updatePackCards();
updateUI();

// ==================================================
// MATERIALS HOTSPOT INTERACTION
// ==================================================
document.querySelectorAll('.mat-hotspot').forEach(dot => {
  dot.addEventListener('mouseenter', () => {
    const id = dot.dataset.pin;
    // Show matching pin label
    document.querySelectorAll('.mat-pin').forEach(pin => {
      pin.classList.toggle('visible', pin.dataset.pinTarget === id);
    });
    // Dim other hotspots
    document.querySelectorAll('.mat-hotspot').forEach(d => {
      d.style.opacity = d.dataset.pin === id ? '1' : '0.3';
    });
  });
  dot.addEventListener('mouseleave', () => {
    document.querySelectorAll('.mat-pin').forEach(pin => pin.classList.remove('visible'));
    document.querySelectorAll('.mat-hotspot').forEach(d => { d.style.opacity = '1'; });
  });
});

// ==================================================
// HERO MINI-FAQ TOGGLE
// ==================================================
function toggleHeroFAQ(btn) {
  const item = btn.parentElement;
  const answer = item.querySelector('.hero-faq-a');
  const isOpen = item.classList.contains('open');

  if (isOpen) {
    answer.style.maxHeight = '0';
    answer.style.padding = '0 18px';
    item.classList.remove('open');
  } else {
    item.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.padding = '0 18px 14px';
  }
}

// ==================================================
// FAQ TOGGLE (smooth animated version)
// ==================================================
function toggleFAQ(btn) {
  const item = btn.parentElement;
  const answer = item.querySelector('.faq-answer');
  const isOpen = item.classList.contains('open');

  if (isOpen) {
    answer.style.maxHeight = '0';
    answer.style.padding = '0';
    item.classList.remove('open');
  } else {
    item.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.padding = '0 0 30px';
  }
}

// Initialize open FAQ items
document.querySelectorAll('.faq-item.open .faq-answer').forEach(answer => {
  answer.style.maxHeight = answer.scrollHeight + 'px';
  answer.style.padding = '0 0 30px';
});

// ==================================================
// READING PROGRESS BAR
// ==================================================
let lastScrollY = 0;
const nav = document.querySelector('.nav');
window.addEventListener('scroll', function() {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  const progress = (scrollTop / docHeight) * 100;
  // Hide nav on scroll down, show on scroll up
  if (scrollTop > lastScrollY && scrollTop > 80) {
    nav.classList.add('nav-hidden');
  } else {
    nav.classList.remove('nav-hidden');
  }
  lastScrollY = scrollTop;
});

// ==================================================
// SCROLL REVEAL — IntersectionObserver
// ==================================================
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');

      // Trigger stat counter animation if this is a stat card
      const statEl = entry.target.querySelector('.stat-number[data-count]');
      if (statEl && !statEl.dataset.animated) {
        animateCounter(statEl);
        statEl.dataset.animated = 'true';
      }
    }
  });
}, {
  threshold: 0.15,
  rootMargin: '0px 0px -40px 0px'
});

document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale').forEach(el => {
  revealObserver.observe(el);
});

// ==================================================
// ANIMATED STAT COUNTERS
// ==================================================
function animateCounter(el) {
  const target = parseInt(el.dataset.count);
  const duration = 1800;
  const start = performance.now();

  function update(now) {
    const elapsed = now - start;
    const progress = Math.min(elapsed / duration, 1);
    // Ease out cubic
    const eased = 1 - Math.pow(1 - progress, 3);
    const current = Math.round(target * eased);
    el.textContent = current + '%';

    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  requestAnimationFrame(update);
}

function openVideoModal(src) {
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.src = src;
  modal.style.display = 'flex';
  requestAnimationFrame(() => {
    modal.classList.add('active');
    video.play();
  });
  document.body.style.overflow = 'hidden';
}

function closeVideoModal(e) {
  if (e && e.target !== e.currentTarget && !e.target.classList.contains('video-modal-close')) return;
  const modal = document.getElementById('videoModal');
  const video = document.getElementById('modalVideo');
  video.pause();
  video.src = '';
  modal.classList.remove('active');
  setTimeout(() => { modal.style.display = 'none'; }, 300);
  document.body.style.overflow = '';
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeVideoModal({target: document.getElementById('videoModal'), currentTarget: document.getElementById('videoModal')});
});

function toggleMoreReviews() {
  const grid = document.querySelector('.sp-grid');
  const btn = document.getElementById('sp-show-more-btn');
  const isExpanded = grid.classList.contains('sp-expanded');
  if (!isExpanded) {
    grid.classList.add('sp-expanded');
    btn.classList.add('expanded');
    btn.innerHTML = 'Show Less <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    // Stagger the animation
    grid.querySelectorAll('.sp-more-item').forEach(function(item, i) {
      item.style.animationDelay = (i * 0.06) + 's';
    });
  } else {
    grid.classList.remove('sp-expanded');
    btn.classList.remove('expanded');
    btn.innerHTML = 'Show More Reviews <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
  }
}

// ==================================================
// TAPE LAYER REVEAL — materials panel
// Hover on pointer devices. Touch has no hover, so there the separation
// plays once when the tape scrolls into view, and tapping toggles it.
// ==================================================
(function () {
  var stage = document.getElementById('tape-layers');
  if (!stage) return;
  if (window.matchMedia('(hover: hover)').matches) {
    stage.addEventListener('mouseenter', function () { stage.classList.add('open'); });
    stage.addEventListener('mouseleave', function () { stage.classList.remove('open'); });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        setTimeout(function () { stage.classList.add('open'); }, 420);
        setTimeout(function () { stage.classList.remove('open'); }, 3600);
        io.unobserve(e.target);
      });
    }, { threshold: 0.55 });
    io.observe(stage);
  }
  stage.addEventListener('click', function () { stage.classList.toggle('open'); });
})();

/* ---------- before/after compare slider ---------- */
(function(){
  var c = document.getElementById('baCompare');
  if (!c) return;
  var h = c.querySelector('.ba-handle');
  function set(p){
    p = Math.max(0, Math.min(100, p));
    c.style.setProperty('--x', p + '%');
    h.setAttribute('aria-valuenow', Math.round(p));
  }
  function pct(e){
    var r = c.getBoundingClientRect();
    return ((e.clientX - r.left) / r.width) * 100;
  }
  var dragging = false, touched = false;
  function claim(){ touched = true; c.classList.remove('ba-ease'); }
  c.addEventListener('pointerdown', function(e){
    dragging = true; claim();
    try { c.setPointerCapture(e.pointerId); } catch(err){}
    set(pct(e));
  });
  c.addEventListener('pointermove', function(e){ if (dragging) set(pct(e)); });
  c.addEventListener('pointerup',     function(){ dragging = false; });
  c.addEventListener('pointercancel', function(){ dragging = false; });
  h.addEventListener('keydown', function(e){
    claim();
    var cur = parseFloat(h.getAttribute('aria-valuenow')) || 50;
    var step = e.shiftKey ? 10 : 2;
    if (e.key === 'ArrowLeft')  { set(cur - step); e.preventDefault(); }
    if (e.key === 'ArrowRight') { set(cur + step); e.preventDefault(); }
    if (e.key === 'Home')       { set(0);   e.preventDefault(); }
    if (e.key === 'End')        { set(100); e.preventDefault(); }
  });
  /* a single attract nudge the first time it scrolls into view, so the
     handle reads as draggable without a instruction anyone has to notice */
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!still && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (!en.isIntersecting || c.dataset.nudged) return;
        c.dataset.nudged = '1';
        c.classList.add('ba-ease');
        function step(v, t){ setTimeout(function(){ if (!touched) set(v); }, t); }
        step(64, 300); step(40, 1050); step(50, 1750);
        setTimeout(function(){ c.classList.remove('ba-ease'); }, 2500);
        io.disconnect();
      });
    }, { threshold: 0.45 });
    io.observe(c);
  }
})();

/* ---------- material panel: play the flip once as it scrolls into view ---------- */
(function(){
  var st = document.querySelector('.mm-stage');
  if (!st || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var timer = null, playing = false;
  function hovered(){ try { return st.matches(':hover'); } catch(e){ return false; } }
  function play(){
    if (playing || hovered()) return;
    playing = true;
    st.classList.add('mm-on');
    timer = setTimeout(function(){
      if (!hovered()) st.classList.remove('mm-on');   /* never yank it out from under a hover */
      playing = false;
    }, 3400);
  }
  function reset(){
    clearTimeout(timer); playing = false;
    if (!hovered()) st.classList.remove('mm-on');
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting && e.intersectionRatio >= 0.5) play();
      else if (!e.isIntersecting) reset();             /* re-arms, so a second pass plays too */
    });
  }, { threshold: [0, 0.5] });
  io.observe(st);
})();

/* Cross-sell cards: hover handles the reveal on a mouse, tap handles it on a
   touch screen. Taps on the link itself are left alone so it still navigates. */
(function(){
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  document.querySelectorAll('.xs-card').forEach(function(card){
    card.addEventListener('click', function(e){
      if (e.target.closest('a')) return;
      card.classList.toggle('xs-show');
    });
  });
})();

window.addEventListener('pageshow', function () { updateUI(); });
